import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useGetMemberQuery } from "../features/members/membersApi";
import { useGetProjectsQuery } from "../features/projects/projectsApi";
import { useAddTaskMutation } from "../features/tasks/tasksApi";

export default function AddTaskForm() {
  const { data: teams } = useGetMemberQuery();
  const { data: projects } = useGetProjectsQuery();

  const [task, setTask] = useState("");
  const [member, setMember] = useState("");
  const [projectName, setProjectName] = useState("");
  const [deadline, setDeadline] = useState("");
  const navigate = useNavigate();

  const [
    addTask,
    {
      isSuccess: isAddTaskSuccess,
      isError: isAddTaskError,
      isLoading: isAddTaskLoaing,
    },
  ] = useAddTaskMutation();

  const resetForm = () => {
    setTask("");
    setMember("");
    setProjectName("");
    setDeadline("");
  };

  useEffect(() => {
    if (isAddTaskSuccess) {
      resetForm();
      navigate("/");
    }
  }, [isAddTaskSuccess, navigate]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const teamMember = teams.filter((team) => team.id === Number(member));
    const project = projects.filter(
      (project) => project.id === Number(projectName)
    );
    const data = {
      taskName: task,
      deadline: deadline,
      teamMember: teamMember[0],
      project: project[0],
      status: "pending",
    };
    addTask(data);
  };
  return (
    <form className="space-y-6" onSubmit={handleSubmit}>
      <div className="fieldContainer">
        <label htmlFor="lws-taskName">Task Name</label>
        <input
          type="text"
          name="taskName"
          id="lws-taskName"
          required
          placeholder="Implement RTK Query"
          value={task}
          onChange={(e) => setTask(e.target.value)}
        />
      </div>

      <div className="fieldContainer">
        <label>Assign To</label>
        <select
          name="teamMember"
          id="lws-teamMember"
          required
          value={member}
          onChange={(e) => setMember(e.target.value)}
        >
          <option value="" hidden>
            Select Job
          </option>
          {teams?.length >= 0 &&
            teams.map((team) => (
              <option value={team.id} key={team.id}>
                {team.name}
              </option>
            ))}
        </select>
      </div>
      <div className="fieldContainer">
        <label htmlFor="lws-projectName">Project Name</label>
        <select
          id="lws-projectName"
          name="projectName"
          required
          value={projectName}
          onChange={(e) => setProjectName(e.target.value)}
        >
          <option value="" hidden>
            Select Project
          </option>
          {projects?.length >= 0 &&
            projects.map((project) => (
              <option value={project.id} key={project.id}>
                {project.projectName}
              </option>
            ))}
        </select>
      </div>

      <div className="fieldContainer">
        <label htmlFor="lws-deadline">Deadline</label>
        <input
          type="date"
          name="deadline"
          id="lws-deadline"
          required
          value={deadline}
          onChange={(e) => setDeadline(e.target.value)}
        />
      </div>

      <div className="text-right">
        <button type="submit" className="lws-submit">
          Save
        </button>
      </div>
      {isAddTaskError && (
        <div className="text-center" style={{ color: "red" }}>
          New task added failed!
        </div>
      )}
      {isAddTaskLoaing && (
        <div className="text-center" style={{ color: "red" }}>
          Adding Task....
        </div>
      )}
      {isAddTaskSuccess && (
        <div className="text-center" style={{ color: "red" }}>
          Task successfully added, redirecting...
        </div>
      )}
    </form>
  );
}
